import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { RouterModule } from '@angular/router';

import {
  NgLabelTemplateDirective,
  NgOptionTemplateDirective,
  NgSelectComponent,
  NgSelectModule,
} from '@ng-select/ng-select';

import { CheckboxComponent } from './Components/Controls/CheckBox/checkbox/checkbox.component';
import { DatePickerComponent } from './Components/Controls/InputDate/date-picker.component';
import { InputFeildComponent } from './Components/Controls/InputFeild/inputFeild.component';
import { InputNumberComponent } from './Components/Controls/InputNumber/inputNumber.component';
import { InputPasswordComponent } from './Components/Controls/InputPassword/inputPassword.component';
import { InputPhoneComponent } from './Components/Controls/inputPhone/input-phone.component';
import { InputSelectComponent } from './Components/Controls/InputSelect/inputSelect.component';
import { InputSwitchComponent } from './Components/Controls/InputSwitch/input-switch.component';
import { InputTextComponent } from './Components/Controls/InputText/inputText.component';
import { TextAreaComponent } from './Components/Controls/InputTextArea/text-area.component';
import { TogglerComponent } from './Components/Controls/toggler/toggler.component';
import { ValidationsComponent } from './Components/Validations/validations.component';
import { ControlValueAccessorDirective } from './Helpers/Directives/controlValueAccessor.directive';
import { PreventSpaceDirective } from './Helpers/Directives/preventSpace.directive';
import { GetControlPipe } from './Helpers/Pipes/getControl.pipe';
import { AngularMaterialModule } from '../AngularMaterialModule/angularMaterial.module';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { FileUploaderFormComponent } from './Components/Controls/FileUploader/fileUploader.component';
import { RadioInputComponent } from './Components/Controls/input-radio/input-radio.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCalendar, MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { InputDateComponent } from './Components/Controls/Input-Date/inputDate.component';
import { InputTimeComponent } from './Components/Controls/InputTime/inputTime.component';
import { DragDropDirective } from "./Components/Controls/FileUploader/drag-drop.directive";

const components = [
  InputFeildComponent,
  InputTextComponent,
  InputNumberComponent,
  InputPasswordComponent,
  InputSelectComponent,
  InputPhoneComponent,
  ValidationsComponent,
  CheckboxComponent,
  TextAreaComponent,
  DatePickerComponent,
  InputSwitchComponent,
  TogglerComponent,
  FileUploaderFormComponent,
  RadioInputComponent,
  InputDateComponent,
  InputTimeComponent,
  InputNumberComponent
  // IntlPhoneNumberComponent,
];
const directives = [ControlValueAccessorDirective, PreventSpaceDirective];

const pipes = [GetControlPipe];

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    TranslateModule,
    AngularMaterialModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    NgLabelTemplateDirective,
    RouterModule,
    CommonModule,
    TranslateModule,
    AngularMaterialModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    DragDropDirective
],
  schemas: [NO_ERRORS_SCHEMA],
  declarations: [...components, ...directives, ...pipes],
  exports: [
    ...components,
    ...directives,
    ...pipes,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' }],
})
export class FormModule {}
